module.exports = __webpack_public_path__ + "static/media/footer-ref-accent.0ab0d1c1.png";